import SvgIcon, { SvgIconProps } from "@mui/material/SvgIcon";

import { colors } from "@dotnet/telematics-design-system";

const DefaultCheckedIcon = (props: SvgIconProps) => {
    const { white } = colors;

    return (
        <SvgIcon {...props}>
            <rect
                x="2"
                y="2"
                width="20"
                height="20"
                rx="10"
                fill="currentColor"
            />

            <circle cx="12" cy="12" r="4" fill={white} />
        </SvgIcon>
    );
};

export default DefaultCheckedIcon;
